"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextWidget = exports.getPreviousWidget = exports.scrollToAnchor = exports.getPathWithAnchor = exports.responsive = void 0;
var responsive = function (breakpoints) {
    return [
        breakpoints.xs,
        breakpoints.sm,
        breakpoints.md,
        breakpoints.lg,
        breakpoints.xl,
        breakpoints.xxl,
    ];
};
exports.responsive = responsive;
var getPathWithAnchor = function (path, anchor) {
    return "".concat(typeof path === "string" ? path : "").concat(anchor ? "#".concat(anchor) : "");
};
exports.getPathWithAnchor = getPathWithAnchor;
var scrollToAnchor = function (event, location, path) {
    if (path) {
        var samePage = location.pathname === event.currentTarget.pathname;
        if (samePage) {
            var _a = event.currentTarget.hash.split("#"), targetHash = _a[1];
            if (targetHash) {
                var targetElement = document.getElementById(targetHash);
                if (targetElement) {
                    event.preventDefault();
                    targetElement === null || targetElement === void 0 ? void 0 : targetElement.scrollIntoView({
                        behavior: "smooth",
                    });
                }
            }
        }
    }
};
exports.scrollToAnchor = scrollToAnchor;
var getPreviousWidget = function (widgets, index, typenamesToExclude) {
    var previousWidget = widgets === null || widgets === void 0 ? void 0 : widgets[index - 1];
    if ((previousWidget === null || previousWidget === void 0 ? void 0 : previousWidget.__typename) &&
        (
        // @ts-expect-error hard to type
        typenamesToExclude === null || typenamesToExclude === void 0 ? void 0 : typenamesToExclude.includes(previousWidget.__typename))) {
        previousWidget = (0, exports.getPreviousWidget)(widgets, index - 1, typenamesToExclude);
    }
    return previousWidget;
};
exports.getPreviousWidget = getPreviousWidget;
var getNextWidget = function (widgets, index, typenamesToExclude) {
    var nextWidget = widgets === null || widgets === void 0 ? void 0 : widgets[index + 1];
    if ((nextWidget === null || nextWidget === void 0 ? void 0 : nextWidget.__typename) &&
        (
        // @ts-expect-error hard to type
        typenamesToExclude === null || typenamesToExclude === void 0 ? void 0 : typenamesToExclude.includes(nextWidget.__typename))) {
        nextWidget = (0, exports.getNextWidget)(widgets, index + 1, typenamesToExclude);
    }
    return nextWidget;
};
exports.getNextWidget = getNextWidget;
